import * as React from 'react'
import {basemapHelper} from '../../helpers'
import {IMapDispatcher} from '../../interfaces/dispatchers'

interface Props {
  basemap: string
  horizontal: boolean
  maxStrech: string
  mapKeys?: string[]
  mapDispatcher: IMapDispatcher
  search: string | null
  pupSearch?: {[key: string]: string | undefined}
}

const BasemapPicker = (props: Props) => {
  const getBasemapDisplayName = (key: string): string => {
    switch (key) {
      case 'empty':
        return 'Без базова карта'
      case 'google-roadmap':
        return 'Google пътна карта'
      case 'google-satellite':
        return 'Google изображения'
      case 'google-hybrid':
        return 'Google сателит'
      case 'google-terrain':
        return 'Google терен'
      case 'esri-topo':
        return 'ESRI топографска'
      case 'esri-satellite':
        return 'ESRI сателит'
      case 'windy-tourist':
        return 'Туристическа карта'
      case 'open-topo':
        return 'Топографска'
      case 'osm':
        return 'Карта улици'
      case 'cartodb-light':
        return 'Светла карта'
      case 'cartodb-darkmatter':
        return 'Тъмна карта'
      case 'cartodb-light-nolabels':
        return 'Светла без надписи'
      case 'cartodb-darkmatter-nolabels':
        return 'Тъмна без надписи'
      case 'stamen-terrain':
        return 'Терен'
      case 'stamen-watercolor':
        return 'Воднист цвят'
      case 'stamen-toner':
        return 'Тонер'
      case 'stamen-toner-light':
        return 'Светъл тонер'
      case 'drone':
        return 'Дрон'
      case 'scan':
        return 'Скенер'
      case 'etk':
        return 'ЕТК'
      default:
        return basemapHelper.ownMapNames.get(key)
    }
  }

  const getBasemapImg = (key: string): JSX.Element => {
    if (basemapHelper.ownMapNames.has(key)) {
      return <img width={100} height={75} style={{width: '100px'}} src={`resources/basemaps/scan.png`} alt=""></img>
    } else
      return <img width={100} height={75} style={{width: '100px'}} src={`resources/basemaps/${key}.png`} alt=""></img>
  }

  const getMaps = (search: string | null): JSX.Element[] => {
    const maps: JSX.Element[] = []
    const keys = props.mapKeys ? props.mapKeys : basemapHelper.getAllBasemaps()
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i]
      if (search && search.length > 0 && getBasemapDisplayName(key).toLowerCase().indexOf(search.toLowerCase()) == -1) {
        continue
      }

      if (
        props.pupSearch &&
        basemapHelper.pupEkatte.get(key) &&
        props.pupSearch.ekatte &&
        basemapHelper.pupEkatte.get(key).indexOf(props.pupSearch.ekatte) == -1
      ) {
        continue
      }

      if (
        props.pupSearch &&
        basemapHelper.pupQuarter.get(key) &&
        props.pupSearch.quarter &&
        basemapHelper.pupQuarter.get(key).indexOf(props.pupSearch.quarter) == -1
      ) {
        continue
      }

      if (
        props.pupSearch &&
        basemapHelper.pupYear.get(key) &&
        props.pupSearch.year &&
        basemapHelper.pupYear.get(key).indexOf(props.pupSearch.year) == -1
      ) {
        continue
      }

      let displayName = getBasemapDisplayName(key)
      // if displayName is longer than 25 characters, truncate it and add ...
      if (displayName.length > 44) {
        displayName = displayName.substring(0, 44) + '...'
      }

      maps.push(
        <div
          key={key}
          onClick={() => props.mapDispatcher.setBasemap(key)}
          onMouseOver={() => {
            const ballow = document.getElementById(`basemap-ballow-${key}`)
            if (ballow) {
              // ballow.style.display = 'block'
              ballow.innerText = getBasemapDisplayName(key)
            }
          }}
          onMouseOut={() => {
            const ballow = document.getElementById(`basemap-ballow-${key}`)
            if (ballow) {
              // ballow.style.display = 'none'
              ballow.innerText = displayName
            }
          }}
          className={'basemap-picker-map' + (props.basemap == key ? ' selected' : '')}
          style={{
            width: props.horizontal ? `${180 / keys.length}%` : '',
            height: !props.horizontal ? `${180 / keys.length}%` : '',
            minWidth: '150px',
            content: '',
            display: 'table',
            clear: 'both'
          }}
        >
          <table style={{width: '250px'}}>
            <tbody>
              <tr>
                <td style={{width: '100px'}}>{getBasemapImg(key)}</td>
                <td id={`basemap-ballow-${key}`} style={{width: '200px', textAlign: 'left'}}>
                  {displayName}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )
    }
    return maps
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: props.horizontal ? 'row' : 'column',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        width: props.horizontal ? props.maxStrech : '',
        height: props.horizontal ? '' : props.maxStrech,
        maxWidth: props.horizontal ? props.maxStrech : '',
        maxHeight: props.horizontal ? '' : props.maxStrech
      }}
    >
      {getMaps(props.search)}
    </div>
  )
}

export default BasemapPicker
